<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import Textarea from '$components/Form/Textarea.svelte';
    import find from 'lodash/find';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const projectTypeOptions = [
        `Résidentiel`,
        `Commercial`,
        `Industriel`,
        `Événementiel`,
        `Autre (veuillez préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const capacityOptions = [
        `Moins de 10 KVA`,
        `10-50 KVA`,
        `50-200 KVA`,
        `200-500 KVA`,
        `Plus de 500 KVA`,
        `Je ne suis pas sûr`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const serviceTypeOptions = [
        `Achat`,
        `Location`,
        `Maintenance`,
        `Réparation`,
        `Installation`,
        `Autre (veuillez préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const brandPreferenceOptions = [
        `Caterpillar`,
        `Cummins`,
        `FG Wilson`,
        `Honda`,
        `Kohler`,
        `Perkins`,
        `SDMO`,
        `Teksan`,
        `Aucune préférence`,
        `Autre (veuillez préciser)`,
    ].map((v) => ({ label: v, value: v }));

    const fuelTypeOptions = [
        `Diesel`,
        `Essence`,
        `Gaz`,
        `Solaire`,
        `Sans préférence`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.groupeElectrogene.projectType}
        class=""
        let:field
        let:id
        label={`Quel est le type de projet pour lequel vous avez besoin d'un groupe électrogène ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={projectTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.groupeElectrogene.capacity}
        class=""
        let:field
        let:id
        label={`Quelle est la capacité en KVA que vous recherchez pour votre groupe électrogène ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[300px]:grid-cols-2 @[500px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={capacityOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.groupeElectrogene.serviceType}
        class=""
        let:field
        let:id
        label={`Quel type de service recherchez-vous ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={serviceTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.groupeElectrogene.brandPreference}
        class=""
        let:field
        let:id
        label={`Avez-vous des préférences pour une marque spécifique de groupe électrogène ?`}
    >
        <MeltMultiSelect
            {form}
            {field}
            {id}
            placeholder=""
            options={brandPreferenceOptions}
            valueToOption={(v) => ({
                value: v,
                label: find(brandPreferenceOptions, (o) => o.value === v)?.label ?? '',
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.groupeElectrogene.fuelType}
        class=""
        let:field
        let:id
        label={`Quel type de carburant préférez-vous ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[300px]:grid-cols-2 @[500px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={fuelTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
